export default __webpack_public_path__ + "static/media/aee-solar.1a27de6e.png";